type CxValue = string | Record<string, unknown> | CxValue[] | undefined | null | false

export function cx(...args: CxValue[]): string {
  const classes: string[] = []

  for (const arg of args) {
    if (!arg) continue

    if (typeof arg === 'string') {
      if (arg) classes.push(arg)
    } else if (Array.isArray(arg)) {
      const nested = cx(...arg)
      if (nested) classes.push(nested)
    } else if (typeof arg === 'object') {
      for (const key in arg) {
        if (arg[key]) classes.push(key)
      }
    }
  }

  return classes.join(' ')
}
